var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirthcake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    width: 45,
    height: 45,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m16 271c0 22.159 12.084 41.537 30 51.928v174.072c0 8.284 6.716 15 15 15h390c8.284 0 15-6.716 15-15v-174.072c17.916-10.391 30-29.769 30-51.928 0-33.084-26.916-60-60-60h-135v-76c0-8.284-6.716-15-15-15h-60c-8.284 0-15 6.716-15 15v76h-135c-33.084 0-60 26.916-60 60zm60 211v-61h360v61zm360-91h-360v-60c17.901 0 33.997-7.881 45-20.354 11.003 12.473 27.099 20.354 45 20.354s33.997-7.881 45-20.354c11.003 12.473 27.099 20.354 45 20.354s33.997-7.881 45-20.354c11.003 12.473 27.099 20.354 45 20.354s33.997-7.881 45-20.354c11.003 12.473 27.099 20.354 45 20.354zm-195-241h30v61h-30zm-165 91h360c16.542 0 30 13.458 30 30s-13.458 30-30 30-30-13.458-30-30c0-8.284-6.716-15-15-15s-15 6.716-15 15c0 16.542-13.458 30-30 30s-30-13.458-30-30c0-8.284-6.716-15-15-15s-15 6.716-15 15c0 16.542-13.458 30-30 30s-30-13.458-30-30c0-8.284-6.716-15-15-15s-15 6.716-15 15c0 16.542-13.458 30-30 30s-30-13.458-30-30c0-8.284-6.716-15-15-15s-15 6.716-15 15c0 16.542-13.458 30-30 30s-30-13.458-30-30 13.458-30 30-30z",
    fill: "currentColor",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m301 75c0-19.166-14.498-75-45-75-30.087 0-45 55.218-45 75 0 24.813 20.187 45 45 45s45-20.187 45-45zm-45 15c-8.271 0-15-6.729-15-15 0-10.675 7.269-34.316 15-43.543 7.808 9.32 15 33.088 15 43.543 0 8.271-6.729 15-15 15z",
    fill: "currentColor",
    "data-original": "#000000",
    className: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthcake);
export default __webpack_public_path__ + "static/media/birthcake.69fceff74b7fb249c645d2dbd86f3cd1.svg";
export { ForwardRef as ReactComponent };